// Vite injects import.meta.env at build time. We validate up-front so a
// missing publishable key fails loud at module load instead of as a cryptic
// Clerk runtime error halfway through the sign-in flow.

interface DashboardEnv {
  readonly clerkPublishableKey: string;
  readonly apiBaseUrl: string;
  readonly docsUrl: string;
}

function readEnv(): DashboardEnv {
  // Vite types `import.meta.env` as `Record<string, any>` — narrow at the
  // boundary so the rest of the app sees `string`.
  const raw: Record<string, unknown> = import.meta.env;
  const clerkPublishableKey = raw['VITE_CLERK_PUBLISHABLE_KEY'];
  const apiBaseUrlRaw = raw['VITE_API_BASE_URL'];
  const docsUrlRaw = raw['VITE_DOCS_URL'];

  if (!clerkPublishableKey || typeof clerkPublishableKey !== 'string') {
    throw new Error(
      'VITE_CLERK_PUBLISHABLE_KEY is required. Copy .env.example to .env.local and fill it in.',
    );
  }
  const apiBaseUrl =
    typeof apiBaseUrlRaw === 'string' && apiBaseUrlRaw.length > 0
      ? apiBaseUrlRaw
      : 'http://localhost:3000';
  const docsUrl =
    typeof docsUrlRaw === 'string' && docsUrlRaw.length > 0
      ? docsUrlRaw
      : 'https://docs.cortexlayer.dev';

  return {
    clerkPublishableKey,
    apiBaseUrl: apiBaseUrl.replace(/\/$/, ''),
    docsUrl: docsUrl.replace(/\/$/, ''),
  };
}

export const env: DashboardEnv = readEnv();
